import $ from 'jquery';
import ProductQuickshop from '../snippets/ProductQuickshop';

export default class ProductItem {
  constructor($el, postMessage) {
    this.$el = $el;
    this.postMessage = postMessage;

    if (this.$el.is('[data-use-quickshop]')) {
      const productQuickshopMarkup = $('[data-quickshop-markup]', this.$el).text();

      try {
        this.productQuickshop = new ProductQuickshop(
          this.$el,
          $(JSON.parse(productQuickshopMarkup)),
          this.postMessage
        );
      } catch(error) {
        console.warn(`Product item: invalid quickshop data found. ${error.message}`);
        return;
      }
    }

    this._objectFitPolyfill();
  }

  _isObjectFitAvailable() {
    return 'objectFit' in document.documentElement.style;
  }

  _objectFitPolyfill() {
    if (this._isObjectFitAvailable()) {
      return;
    }

    const $figure = $('[data-product-item-image]', this.$el);
    const featuredSrc = $('img:not(.product-image-alternate)', $figure).attr('src');
    const alternateSrc = $('.product-image-alternate', $figure).attr('src');

    $figure.addClass('product-item-image-no-objectfit');
    $figure.css('background-image', `url("${featuredSrc}")`);

    if (alternateSrc) {
      this.$el.on('mouseover', () => {
        $figure.css('background-image', `url("${alternateSrc}")`);
      });

      this.$el.on('mouseleave', () => {
        $figure.css('background-image', `url("${featuredSrc}")`);
      });
    }
  }

  unload() {
    if (this.productQuickshop) {
      this.productQuickshop.unload();
    }
  }
}
